import { createContext } from 'react'

const ActivityModalContext = createContext()

export default ActivityModalContext
